import { formatBytes } from '../utilities/format';

export interface GridStats {
  rows: number;
  pages: number;
  size: number;
}

/**
 * Row 1 of the resource-grid toolbar — the React port of resource_filter.html's top
 * row: resources/pages/size stats on the left, and an optional right-aligned slot for
 * the Add Tag control (Angular put the stats and the iio-add-tag box on one visual row).
 * The button strip (refresh, reports, batches, view toggle, columns, select-all) is
 * row 2, assembled by ResourceGrid.
 */
export function ResourceGridToolbar({
  stats,
  children,
}: {
  stats: GridStats | null;
  children?: React.ReactNode;
}) {
  return (
    // All row-1 items (3 stats + Add Tag) are direct children so justify-content:
    // space-between distributes the four evenly across the row.
    <div className="resource-grid-toolbar" data-testid="resource-grid-stats-panel">
      <span className="lead text-muted" data-testid="resource-grid-resource-count-item"><i className="fas fa-list fa-fw" /> {stats ? stats.rows.toLocaleString() : '??'} Resources</span>
      <span className="lead text-muted" data-testid="resource-grid-page-count-item"><i className="fas fa-file-alt fa-fw" /> {stats ? stats.pages.toLocaleString() : '??'} Pages</span>
      <span className="lead text-muted" data-testid="resource-grid-size-item"><i className="fas fa-database fa-fw" /> {stats ? formatBytes(stats.size) : '??'}</span>
      {children && <div className="resource-grid-addtag">{children}</div>}
    </div>
  );
}
